import React, { forwardRef } from "react";
import { Scrollbar } from "@smartsuite/react-ui/lib/components/utils/Scrollbar/Scrollbar";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { text } from "../text";
export const EditorMentionMenuRaw = ({ children }, ref) => {
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", { ref: ref, className: "editor-mention-menu", onMouseDown: (e) => e.preventDefault() },
        React.createElement(Scrollbar, { noScrollX: true, translateContentSizeYToHolder: true, classes: "editor-mention-menu__scrollbar", gutterRight: 1, gutterTop: 4, gutterBottom: 4 },
            React.createElement("div", { className: "editor-mention-menu__body" }, children)),
        React.createElement("div", { className: "editor-mention-menu__footer" },
            React.createElement("button", { className: "editor-mention-menu__footer-item" },
                React.createElement(Text, { color: "primary", size: "l", weight: "medium" }, "\u2191\u2193"),
                React.createElement(Text, { color: "secondary", size: "xs", weight: "regular" }, text.toNavigate)),
            React.createElement("button", { className: "editor-mention-menu__footer-item" },
                React.createElement(Text, { color: "primary", size: "l", weight: "medium" }, "\u23CE"),
                React.createElement(Text, { color: "secondary", size: "xs", weight: "regular" }, text.toSelect)),
            React.createElement("button", { className: "editor-mention-menu__footer-item" },
                React.createElement(Text, { color: "primary", size: "xs", weight: "medium" }, "esc"),
                React.createElement(Text, { color: "secondary", size: "xs", weight: "regular" }, text.toDismiss)))));
};
export const EditorMentionMenu = forwardRef(EditorMentionMenuRaw);
